import React, {useState, useEffect} from "react";
import { InputText, SelectDropdown } from "commons/input-controls";
import AlignButtons from "pages/report-constructor/align-buttons/align-buttons";
import DataFieldsContainer from "pages/report-constructor/items/data-fields/data-fields.container";
import s from "./pie-chart-component.module.scss";

const PieChartComponent = (props) => {

    const [fields, setFields] = useState(props.parameters && props.parameters.ANALYTICS_PARAMETERS && props.parameters.ANALYTICS_PARAMETERS.fields ? props.parameters.ANALYTICS_PARAMETERS.fields : []); 
    const [parameters, setParameters] = useState(props.parameters && props.parameters.parameters ? props.parameters.parameters : null);
    const [rerender, setRerender] = useState(false);

    useEffect(() => {
        setParameters(props.parameters && props.parameters.parameters ? props.parameters.parameters : null);
    }, [props]);

    const updateParameters = (type, parameter, value) => {
        let params = {...parameters};
        let analyticParams = {...params[type]}
        analyticParams.fields = value;
        params[type] = analyticParams;
        if(value === ''){
            delete params[type][parameter];
        }
        props.updateComponent(props.index, params)
    }

    const align = (align) => {
        let params = {...parameters};
        params.ALIGNMENT = align;
        props.updateComponent(props.index, params);
    }

    return (
        <div className={s.PieChartComponent}>
            <div className={s.selectData}>
                <div className={s.selectRow}>
                <AlignButtons alignItems={align} getValue={props.getValue} alignment={parameters.ALIGNMENT ? parameters.ALIGNMENT : null}/>
                    {/*<SelectDropdown width={113} items={props.fields} selected={selectedFirst} setSelected={setSelectedFirst}/>*/}
                                    <DataFieldsContainer 
                                                        parameters={parameters.ANALYTICS_PARAMETERS}
                                                        setParameters={updateParameters}
                                                        type={'ANALYTICS_PARAMETERS'}
                                                        availableFields={['first']}
                                                        readOnly={props.isReadOnly}
                                                    />
                </div>
            </div>
        </div>
    )
}

export default PieChartComponent;